import shutdownReducer from './slice';

export default shutdownReducer;
